import React from 'react';
import ToolCard from './ToolCard';
import * as FiIcons from 'react-icons/fi';

const { 
  FiLayers, 
  FiCalendar, 
  FiCpu, 
  FiZap, 
  FiEdit3, 
  FiMail, 
  FiBarChart2, 
  FiBookOpen,
  FiMonitor 
} = FiIcons;

const ToolGrid = () => {
  const sections = [
    {
      title: "Productivity & Systems",
      tools: [
        {
          name: "Notion",
          icon: FiLayers,
          description: "The OS for my entire life and business. Every template I sell is built here.",
          url: "https://notion.so"
        },
        {
          name: "Forento",
          icon: FiMonitor,
          description: "All in One, Course and digital Product Hosting tool. Perfect for scaling your knowledge business.",
          url: "https://forento.io?r=MDEPPE"
        },
        {
          name: "Tidycal",
          icon: FiCalendar,
          description: "Simple, effective calendar booking tool that eliminates the back-and-forth of scheduling.",
          url: "https://appsumo.8odi.net/2rGo0g"
        },
        {
          name: "Greta",
          icon: FiBookOpen,
          description: "Nocode Tool to build fast Webpages with professional design and speed.",
          url: "http://greta.questera.ai/?via=mathias"
        }
      ]
    },
    {
      title: "AI & Creation",
      tools: [
        {
          name: "ChatGPT",
          icon: FiZap,
          description: "My non-judgmental brainstorming partner for breaking through mental blocks.",
          url: "https://chat.openai.com"
        },
        {
          name: "Supermachine",
          icon: FiCpu,
          description: "AI Image Generator with 65+ AI Models for high-quality visual content.",
          url: "https://supermachine.art/?ref=mathiasdeppe22"
        },
        {
          name: "Mootion",
          icon: FiEdit3,
          description: "Revolutionary video creation with AI, making professional production accessible.",
          url: "https://www.mootion.com/?via=mathias"
        }
      ]
    },
    {
      title: "Marketing",
      tools: [
        {
          name: "Sendfox",
          icon: FiMail,
          description: "Reliable automation and email marketing that stays out of the way so you can create.",
          url: "https://appsumo.8odi.net/qnrj5N"
        },
        {
          name: "Profittree",
          icon: FiBarChart2,
          description: "The essential tool to find hot products and winning niches on Etsy.",
          url: "https://profittree.io/?via=mathias40"
        }
      ]
    }
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {sections.map((section, sIdx) => (
          <div key={section.title} className={sIdx !== 0 ? "mt-24" : ""}>
            <div className="flex items-center gap-4 mb-10">
              <h2 className="text-xl font-black uppercase tracking-widest text-zinc-950">
                {section.title}
              </h2>
              <div className="h-px bg-zinc-100 flex-grow" />
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {section.tools.map((tool, tIdx) => (
                <ToolCard key={tool.name} {...tool} index={tIdx} />
              ))}
            </div>
          </div>
        ))}
        
        <div className="mt-32 pt-12 border-t border-zinc-100 text-center">
          <p className="text-sm text-zinc-400 max-w-md mx-auto italic">
            Some of these are affiliate links. I only recommend tools I use daily to run my business and bypass paralysis.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ToolGrid;